import { css } from '@emotion/react';

export const label = css`
  margin-bottom: 0.8rem;
  font-size: 1.4rem;
  display: flex;
  gap: 8px;
`;

export const message = (helperTextFontSize: string) => css`
  display: flex;
  justify-content: space-between;
  margin-top: 0.8rem;
  font-size: ${helperTextFontSize ? helperTextFontSize : '1.2rem'};
`;

export const helperText = css`
  color: var(--color-foreground-neutral);
`;

export const errorMessage = css`
  color: var(--color-secondary-default);
`;

export const lengthOver = css`
  color: var(--color-secondary-default);
`;

export const labelRequired = css`
  font-weight: 700;
  font-size: 12px;
  line-height: 150%;
  align-items: center;
  color: var(--color-secondary-default);
`;
